import React from "react";
export default function HealthCheck() {
  const status = {
    message: "Frontend is running successfully",
    timestamp: new Date().toISOString(),
    status: "success",
  };

  return (
    <pre className="text-left p-6 bg-gray-100 text-green-700 rounded-md">
      {JSON.stringify(status, null, 2)}
    </pre>
  );
}
